/*
 * @Author: Src
 * @Date: 2026-09-01 15:02:52
 * @LastEditTime: 2026-09-02 09:02:07
 * @LastEditors: Src
 * @FilePath: /work-station/src/router/supplyChainRouter/salesOrderRoutes.ts
 * @Description: 供应商销售单模块
 */

import { RouteConfig } from 'vue-router';
import Main from '@/views/Main.vue';
import SalesOrder from '@/views/supplyChain/supplier/SalesOrder.vue';
import { AuthEnum } from '@/services/permission.service';


const salesOrderRoutes: RouteConfig = {
    path: '/salesOrder',
    name: 'salesOrder',
    component: Main,
    meta: { title: '销售单列表' },
    redirect: {
      name: 'salesOrderList',
    },
    children: [
      {
        path: 'list',
        name: 'salesOrderList',
        component: SalesOrder,
        meta: { title: '销售单列表' },
        props: {
          auth: [AuthEnum.销售单列表],
        },
      },
    ],
  };
export default salesOrderRoutes;
